import { render } from "./PedidosLocalizacao.vue?vue&type=template&id=f5a64c28"
import script from "./PedidosLocalizacao.vue?vue&type=script&lang=js"
export * from "./PedidosLocalizacao.vue?vue&type=script&lang=js"

import "./PedidosLocalizacao.vue?vue&type=style&index=0&id=f5a64c28&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__